module.exports = __webpack_public_path__ + "static/media/brand-yummy.2bbb2b8e.png";